'use strict';
module.exports = require('../../full/object/from-entries');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/features/object/from-entries.js
// module id = 351
// module chunks = 0